// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        try {
          const { data: org } = await api.get("/orgs/me");
          if (org) {
            navigate("/dashboard", { replace: true, state: { user: data } });
          } else {
            navigate("/onboarding", { replace: true, state: { user: data } });
          }
        } catch {
          navigate("/onboarding", { replace: true, state: { user: data } });
        }
      } catch (e) {
        console.error(e);
        await checkAuth();
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center text-emerald-500 font-heading text-3xl tracking-widest">
      AUTENTICANDO...
    </div>
  );
}
